import {
  effect,
  inject,
  makeEnvironmentProviders,
  provideEnvironmentInitializer,
  untracked,
} from '@angular/core';
import {
  Firestore,
  doc,
  getDoc,
  increment,
  serverTimestamp,
  setDoc,
} from '@fido/firebase/firestore';
import { FingerprintJSPro } from '@fingerprintjs/fingerprintjs-pro-angular';
import { FpjsSpaResponse } from '@fingerprintjs/fingerprintjs-pro-spa';
import { injectUser } from '../../auth/data/user';
import { provideFingerprintjsPro } from '../utils/fingerprint-provider';
import { injectFingerprint } from './fingerprint';

export function provideDeviceTracking() {
  return makeEnvironmentProviders([
    provideFingerprintjsPro(),
    provideEnvironmentInitializer(() => {
      const firestore = inject(Firestore);
      const currentUser = injectUser();
      const fingerprintResource = injectFingerprint();

      effect(() => {
        const user = currentUser();
        const fingerprintData = fingerprintResource.value();

        if (user && fingerprintData)
          untracked(() => trackDevice(firestore, user.uid, fingerprintData));
      });
    }),
  ]);
}

async function trackDevice(
  firestore: Firestore,
  uid: string,
  result: FpjsSpaResponse<FingerprintJSPro.ExtendedGetResult>,
) {
  const sessionKey = `device-tracked-${uid}-${result.visitorId}`;
  const lastTracked = sessionStorage.getItem(sessionKey);
  const now = Date.now();

  if (lastTracked && now - Number.parseInt(lastTracked) < 3600000) {
    return;
  }

  try {
    const ref = doc(firestore, `users/${uid}/devices/${result.visitorId}`);
    const existingDoc = await getDoc(ref);

    await setDoc(
      ref,
      existingDoc.exists()
        ? {
            ...result,
            lastSeen: serverTimestamp(),
            visitCount: increment(1),
          }
        : {
            ...result,
            firstSeen: serverTimestamp(),
            lastSeen: serverTimestamp(),
            visitCount: 1,
          },
      { merge: true },
    );

    sessionStorage.setItem(sessionKey, now.toString());
  } catch (error) {
    console.error('Failed to track device:', error);
  }
}
